// Tile background behind a vendor logo: admin choice, else the given default.
export const logoBg = (item, fallback = 'bg-white') => {
  if (item?.logo_bg === 'dark') return 'bg-slate-900';
  if (item?.logo_bg === 'white') return 'bg-white';
  return fallback;
};
